import { config } from 'src/app/environment-config';
export const EP_NOT_AUTHORIZED = 'NOT_AUTHORIZED';
export const SILENT_AUTH_IFRAME_NAME = 'GBM Auth';
export const WAITING_TIME_FOR_TIMEOUT = 5000;
const env = config();
export const EP_PUBLIC_URL = env.EL_PATRON.URL_BASE;

export class SilentAuth {
  private callback: (
    accessToken?: string | boolean,
    identityToken?: string,
  ) => void;
  private iframe: HTMLIFrameElement;
  private timeoutInterval: any;

  constructor(
    callback: (accessToken?: string | boolean, identityToken?: string) => void,
  ) {
    this.callback = callback;
  }

  init = (iframeUrl: string) => {
    const authIframes = window.document.querySelectorAll(
      `iframe[name="${SILENT_AUTH_IFRAME_NAME}"]`,
    );

    /* istanbul ignore else */
    if (!authIframes.length) {
      this.iframe = window.document.createElement('iframe');
      this.iframe.style.display = 'none';
      this.iframe.src = iframeUrl;
      this.iframe.name = SILENT_AUTH_IFRAME_NAME;
      window.document.body.appendChild(this.iframe);
      window.addEventListener('message', this.handleIframeTask);
      this.startTimeoutListener();
    }
  };

  removeIframe = () => this.iframe.remove();

  handleIframeTask = async (e: MessageEvent) => {
    if (e.origin !== EP_PUBLIC_URL) {
      return;
    }

    if (e.data === EP_NOT_AUTHORIZED) {
      this.removeIframe();
      console.warn(EP_NOT_AUTHORIZED);
      this.callback(false);
    }

    if (e.data && e.data.accessToken) {
      const { accessToken, idToken } = e.data;
      this.clearTimeoutListener();
      window.removeEventListener('message', this.handleIframeTask);
      this.removeIframe();
      this.callback(accessToken, idToken);
    }
  };

  private startTimeoutListener() {
    this.timeoutInterval = setInterval(() => {
      this.removeIframe();
      console.warn('timeout for communication reached!');
      this.callback(false);
    }, WAITING_TIME_FOR_TIMEOUT);
  }

  private clearTimeoutListener() {
    clearInterval(this.timeoutInterval);
  }
}
